<template>
  <div>
    <header class="top-0 w-full fixed h-14 px-3 flex space-x-3 overflow-x-auto flex-row no-scrollbar rounded-b-lg shadow bg-white place-items-center">
      <button 
        v-for="category in menuMergedItems" 
        class="rounded-lg text-second font-medium text-xs px-5 h-8 bg-category focus:bg-primary focus:text-white transition-all whitespace-nowrap"
        :key="`list-${category.id}`"
        @click="scrollToCategory(`category-items-${category.id}`)"
      >
        {{ category.name }}
      </button>
    </header>
    
    <div class="pt-14">
      <div v-for="category in menuMergedItems" :key="category.id" :id="`category-items-${category.id}`">
        <div class="ml-5 my-3 text-second text-2xl font-extrabold">{{ category.name }}</div>

        <div class="grid grid-cols-2 grid-flow-row auto-rows-min ">
          <template v-for="item in category.items">
            <DishItem v-if="item.price != undefined" class="mb-2" :key="`item-${item.id}`" :item="item"/>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DishItem from './DishItem'

export default {
  props: {
		menuMergedItems: {
			type: Array,
			default: Array
		}
	},

	data: () => ({
	}),

	methods: {
		scrollToCategory(categoryId) {
			const el = document.getElementById(categoryId)
			el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      })
		}
	},

	components: { DishItem }
}
</script>

<style>
.no-scrollbar::-webkit-scrollbar { 
  display: none; 
} 
</style>